import { useState, useCallback } from 'react';

const R = 6371;
function haversine(la1, lo1, la2, lo2) {
  const dLa = (la2 - la1) * Math.PI / 180;
  const dLo = (lo2 - lo1) * Math.PI / 180;
  const a = Math.sin(dLa / 2) ** 2 + Math.cos(la1 * Math.PI / 180) * Math.cos(la2 * Math.PI / 180) * Math.sin(dLo / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

let nextId = 1;

export function usePOIs(mainLatLng) {
  const [pois, setPois] = useState([]);

  const addPOI = useCallback(({ lat, lng, name, iconKey = 'marker' }) => {
    const id = nextId++;
    const poi = {
      id, lat, lng, name, iconKey,
      distance: mainLatLng ? haversine(mainLatLng.lat, mainLatLng.lng, lat, lng) : undefined,
    };
    setPois(prev => [...prev, poi]);
    return id;
  }, [mainLatLng]);

  const removePOI = useCallback((id) => {
    setPois(prev => prev.filter(p => p.id !== id));
  }, []);

  const updatePOIName = useCallback((id, name) => {
    setPois(prev => prev.map(p => p.id === id ? { ...p, name } : p));
  }, []);

  const updatePOIIcon = useCallback((id, iconKey) => {
    setPois(prev => prev.map(p => p.id === id ? { ...p, iconKey } : p));
  }, []);

  const updatePOIPosition = useCallback((id, lat, lng) => {
    setPois(prev => prev.map(p => {
      if (p.id !== id) return p;
      const distance = mainLatLng ? haversine(mainLatLng.lat, mainLatLng.lng, lat, lng) : undefined;
      return { ...p, lat, lng, distance };
    }));
  }, [mainLatLng]);

  const recalcDistances = useCallback((newMainLatLng) => {
    if (!newMainLatLng) return;
    setPois(prev => prev.map(p => ({
      ...p,
      distance: haversine(newMainLatLng.lat, newMainLatLng.lng, p.lat, p.lng),
    })));
  }, []);

  return { pois, addPOI, removePOI, updatePOIName, updatePOIIcon, updatePOIPosition, recalcDistances };
}
